import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import useTimeout from '../../hooks/useTimeout';


/**
 * Happy clicker protection component wrapper
 */
function Click({children, onClick}) {

    const [isClicked, setIsClicked] = useState(false);
    useEffect(() => {

        if (!isClicked) {

            return;
        }

        const timeout = useTimeout(() => setIsClicked(false));

        return () => timeout.clear();

    }, [isClicked]);

    return (
        <span
            onClick={event => {

                event.preventDefault();
                if (isClicked) {

                    return;
                }
                setIsClicked(true);

                onClick();
            }}
        >
            {children}
        </span>
    );
}


Click.propTypes = {
    children: PropTypes.any.isRequired,
    onClick: PropTypes.func.isRequired
};

Click.defaultProps = {
};


export default Click;
